module.exports = __webpack_public_path__ + "static/media/r_dot_14.24b3b5ad.png";